import { Component } from '@angular/core';
import { ListComponent } from 'src/app/common/component/list.component';

@Component({
	selector: 'app-users-list',
	templateUrl: './users-list.component.html',
	styleUrls: ['./users-list.component.css'],
})
export class UsersListComponent extends ListComponent {
	protected itemsBeforeDataLoad = 0;
	protected apiUrl = 'users';
	data: Array<any>;
	tableRows = [
		{ id: 'lastName', name: 'Nazwisko' },
		{ id: 'firstName', name: 'Imię' },
		{ id: 'email', name: 'E-Mail' },
	];
	filters = {
		status: 1,
	};
}
